import { FiSelectSearchChipsTriggerComponent } from './fi-select-search-chips-trigger/fi-select-search-chips-trigger.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { MatSelectModule } from '@angular/material/select';
import { FiSelectSearchComponent } from './select-search.component';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FiSelectSearchItemComponent } from './fi-select-search-item/fi-select-search-item.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiHighlightModule } from '@fi-shared/highlight';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule, MatPseudoCheckbox } from '@angular/material/core';
import { FiSelectSearchMultiLevelComponent } from './fi-select-search-multi-level/fi-select-search-multi-level.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FiChipsSelectSearchComponent } from '@fi-shared/fi-select-search/fi-chips-select-search/fi-chips-select-search.component';
import { FiChipsGroupOptionsSelectSearchComponent } from './fi-chips-select-search/fi-chips-group-options-select-search/fi-chips-group-options-select-search.component';
import { FiChipsSelectSearchHelperService } from '@fi-shared/fi-select-search/fi-chips-select-search/fi-chips-select-search-helper.service';
import { FiChipsCheckboxSelectSearchComponent } from '@fi-shared/fi-select-search/fi-chips-select-search/fi-chips-checkbox-select-search/fi-chips-checkbox-select-search.component';
import { FiConnectedDropdownItemsModule } from '@fi-shared/fi-connected-dropdown-items/fi-connected-dropdown-items.module';
import { FiFoldableSelectItemSearchComponent } from '@fi-shared/fi-select-search/fi-foldable-select-item-search/fi-foldable-select-item-search.component';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
    declarations: [
        FiSelectSearchComponent,
        FiChipsSelectSearchComponent,
        FiSelectSearchItemComponent,
        FiSelectSearchMultiLevelComponent,
        FiChipsGroupOptionsSelectSearchComponent,
        FiChipsCheckboxSelectSearchComponent,
        FiFoldableSelectItemSearchComponent,
        FiSelectSearchChipsTriggerComponent,
    ],
    exports: [
        FiSelectSearchComponent,
        FiChipsSelectSearchComponent,
        FiSelectSearchItemComponent,
        FiSelectSearchMultiLevelComponent,
        FiChipsGroupOptionsSelectSearchComponent,
        FiChipsCheckboxSelectSearchComponent,
        FiFoldableSelectItemSearchComponent,
        FiSelectSearchChipsTriggerComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        CommonModule,
        FiAppTextSharedModule,
        MatSelectModule,
        MatOptionModule,
        MatFormFieldModule,
        MatInputModule,
        ScrollingModule,
        MatChipsModule,
        MatIconModule,
        MatAutocompleteModule,
        FiProfileIconModule,
        FiHighlightModule,
        MatButtonModule,
        MatCheckboxModule,
        MatPseudoCheckbox,
        FiConnectedDropdownItemsModule,
        MatDividerModule,
    ],
    providers: [FiChipsSelectSearchHelperService],
})
export class SelectSearchModule {}
